'use client';
import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import {
  LAZY_SECTION_IN_VIEW_OPTIONS,
  useInView,
} from '@/shared/hooks/useInView';
import { getBrandData } from '@/shared/hooks/useBrandTheme';
import { getCurrentBrand } from '@/shared/config/brand-by-target.mjs';
import DynamicJackpotLobbyWidget from '@/widgets/jackpot-component';
import { JpWrapper } from './styles';

export const JackpotSection = () => {
  const [jpRef, jpIsVisible] = useInView(LAZY_SECTION_IN_VIEW_OPTIONS);
  const router = useRouter();
  const jackpotEnabled = getBrandData().brandTheme.features.jackpot;

  const handleJackpotClick = useCallback(() => {
    router.push(getCurrentBrand() === 'pw' ? 'games/pingwin' : 'games/vamos');
  }, [router]);

  if (!jackpotEnabled) return null;

  return (
    <JpWrapper ref={jpRef}>
      {jpIsVisible && (
        <DynamicJackpotLobbyWidget onClick={handleJackpotClick} />
      )}
    </JpWrapper>
  );
};
